import { ReactElement, SVGProps } from 'react';
import { ReactComponent as LatamIconComponent } from './latam-icon.svg';

export const LatamIcon = (props: SVGProps<SVGSVGElement>): ReactElement => {
  return <LatamIconComponent {...props} />;
};
